"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LostPasswordForm;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uiLibrary = require("@printdeal/ui-library");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function LostPasswordForm(_ref) {
  var handleChange = _ref.handleChange,
    handleSubmit = _ref.handleSubmit,
    email = _ref.email,
    loading = _ref.loading;
  var intl = (0, _reactIntl.useIntl)();
  return /*#__PURE__*/_react["default"].createElement(_uiLibrary.Root, {
    as: "form",
    onSubmit: handleSubmit,
    className: "pd-max-w-2xl pd-flex pd-flex-col pd-gap-3",
    method: "POST"
  }, /*#__PURE__*/_react["default"].createElement(_uiLibrary.TextField, {
    id: "email",
    required: true,
    requiredLabel: intl.formatMessage({
      id: 'general.form.requiredLabel',
      defaultMessage: 'Required field'
    }),
    name: "email",
    value: email,
    type: "email",
    disabled: loading,
    onChange: handleChange,
    autoComplete: "username",
    label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      defaultMessage: "Email",
      id: "account.lostpassword.form.label.email"
    })
  }), /*#__PURE__*/_react["default"].createElement(_uiLibrary.Button, {
    disabled: loading,
    type: "submit",
    isLoading: loading,
    className: "pd-w-full"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    defaultMessage: "Submit",
    id: "account.lostpassword.button.text"
  })));
}
LostPasswordForm.defaultProps = {
  loading: false
};
LostPasswordForm.propTypes = {
  handleChange: _propTypes["default"].func.isRequired,
  handleSubmit: _propTypes["default"].func.isRequired,
  email: _propTypes["default"].string.isRequired,
  loading: _propTypes["default"].bool
};